//
// SelectionOptions.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "../models/BaseUIModel";
import "../models/data/hierarchy/Hierarchy";

var SelectionOptions = createModule("commons::SelectionOptions", ["commons::PropertyOwner","commons::BaseModel","commons::BaseUIModel"], EventDispatcher, [
    ,
    {
        includeAllOther: 2,
        includeMissing: 2,
        hierarchies: [1],
        includeDrillInSelections: 2,
        expectedDataNames: [7],
        expectedVariableNames: [7],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default SelectionOptions;
